import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#fe0101',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M12.509,43.391l6.375,3.623-6.375,3.623ZM30,35.214V58.786A3.215,3.215,0,0,1,26.786,62H3.214A3.215,3.215,0,0,1,0,58.786V35.214A3.215,3.215,0,0,1,3.214,32H26.786A3.215,3.215,0,0,1,30,35.214ZM27.188,47.02a32.177,32.177,0,0,0-.509-5.906,3.057,3.057,0,0,0-2.156-2.17c-1.9-.516-9.522-.516-9.522-.516s-7.627,0-9.522.516a3.057,3.057,0,0,0-2.156,2.17,34.526,34.526,0,0,0,0,11.813,3.013,3.013,0,0,0,2.156,2.136c1.9.509,9.522.509,9.522.509s7.627,0,9.522-.516a3.013,3.013,0,0,0,2.156-2.136A32.078,32.078,0,0,0,27.188,47.02Z"
          transform="translate(0 -32)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
